import React, { useEffect, useMemo, useState } from 'react';
import { latLngToCell } from 'h3-js';
import {
  API_GATEWAY_URL, H3_HEXAGON_RES, IS_PRODUCTION, findAreaAtPoint
} from './utils';
import { useSessionContext } from './SessionContext';
import GeoSearch, { FetchingLocationBar } from './GeoSearch';
import LocationPanel from './LocationPanel';

const getLocationFromSearchResult = async ({ placeID }) => {
  const url = new URL(`${API_GATEWAY_URL}/location`);
  const params = new URLSearchParams({
    placeID,
    source: IS_PRODUCTION ? 'wli-map' : 'debug'
  });
  const response = await fetch(`${url}?${params}`);
  const data = await response.json();
  return data;
};

export default function LeftPanel() {
  const {
    selectedLocation, setSelectedLocation, viewMode, shapes
  } = useSessionContext();
  const [selectedSearchResult, setSelectedSearchResult] = useState();

  useEffect(() => {
    if (!selectedSearchResult) return;
    const task = async () => {
      const location = await getLocationFromSearchResult(selectedSearchResult);
      const { lat, lng } = location;
      setSelectedSearchResult();

      /* Which area contains the searched point.
       *
       * In hexagon mode that is `latLngToCell`, a pure function of the coordinate. In
       * administrative mode there is no such function: the answer depends on the
       * boundary set, so it is a point-in-polygon test against the loaded shapes. A
       * point in an area with no gauges -- most of the ocean, all of Canada outside the
       * seven census divisions that survive the ECCC licence exclusion -- resolves to
       * nothing, and the panel then shows the nearby-gauge summary without a WLI, which
       * is the correct answer rather than a failure.
       */
      const areaKey = viewMode === 'adm'
        ? (findAreaAtPoint(shapes && shapes.features, Number(lng), Number(lat)) || {}).id
        : latLngToCell(lat, lng, H3_HEXAGON_RES);

      setSelectedLocation({ ...location, areaKey, hexagonCode: areaKey });
    };
    task();
  }, [selectedSearchResult, viewMode, shapes]);

  const leftPanelContents = useMemo(() => {
    if (selectedLocation) return <LocationPanel />;
    if (selectedSearchResult) return <FetchingLocationBar />;
    return <GeoSearch setSelectedSearchResult={setSelectedSearchResult} />;
  }, [selectedLocation, selectedSearchResult, setSelectedSearchResult]);

  return (
    <div className="left-panel">
      {leftPanelContents}
    </div>
  );
}
